/**
 * Money display.
 *
 * The API sends integer paise and this module is the only thing that turns
 * them into text. Nothing in the storefront ever does arithmetic on a rupee
 * float - totals are summed in paise and formatted once, at the edge.
 */

const formatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const preciseFormatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * `129900` → `₹1,299`.
 *
 * Whole rupees by default: fashion pricing is round, and trailing `.00` on a
 * listing grid is visual noise. Anything with paise falls back to two decimals
 * automatically rather than silently rounding a real amount away.
 */
export function formatPrice(paise: number): string {
  const rupees = paise / 100;
  return paise % 100 === 0 ? formatter.format(rupees) : preciseFormatter.format(rupees);
}

/** Always two decimals - used at checkout, where exactness reassures. */
export function formatPriceExact(paise: number): string {
  return preciseFormatter.format(paise / 100);
}

export function sumPaise(values: number[]): number {
  return values.reduce((total, value) => total + value, 0);
}
